import {ALERT_SHOW} from "@/store/actions/alert";

import penaltyTariffAPI from "@/utils/axios/penalty_tariff"
import {
    GET_ALL_PENALTY_TARIFF,
    CREATE_PENALTY_TARIFF,
    UPDATE_PENALTY_TARIFF,
    DELETE_PENALTY_TARIFF
} from "@/store/actions/penalty_tariff";
import {START_MODAL_LOADING, STOP_MODAL_LOADING} from "@/store/actions/loading";

const state = { penalty_tariffs: [] }

const getters = {
    getPenaltyTariffs: state => state.penalty_tariffs,
}

const actions = {
    [GET_ALL_PENALTY_TARIFF]: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            penaltyTariffAPI.get_all(payload)
                .then(response => response.data)
                .then(data => {
                    commit(GET_ALL_PENALTY_TARIFF, data)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
        })
    },
    [CREATE_PENALTY_TARIFF]: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            commit(START_MODAL_LOADING)
            penaltyTariffAPI.create(payload)
                .then(response => response.data)
                .then(data => {
                    commit(CREATE_PENALTY_TARIFF, data)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
                .finally(() => commit(STOP_MODAL_LOADING))
        })
    },
    [UPDATE_PENALTY_TARIFF]: ({ commit }, payload) => {
        commit(START_MODAL_LOADING)
        return new Promise((resolve, reject) => {
            penaltyTariffAPI.update(payload)
                .then(response => response.data)
                .then(data => {
                    commit(UPDATE_PENALTY_TARIFF, data)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
                .finally(() => commit(STOP_MODAL_LOADING))
        })
    },
    [DELETE_PENALTY_TARIFF]: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            commit(START_MODAL_LOADING)
            penaltyTariffAPI.remove(payload)
                .then(response => response.data)
                .then(data => {
                    commit(DELETE_PENALTY_TARIFF, data)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
                .finally(() => commit(STOP_MODAL_LOADING))
        })
    }
}

const mutations = {
    [GET_ALL_PENALTY_TARIFF]: (state, payload) => {
        state.penalty_tariffs = payload
    },
    [CREATE_PENALTY_TARIFF]: (state, payload) => {
        state.penalty_tariffs.push(payload)
    },
    [UPDATE_PENALTY_TARIFF]: (state, payload) => {
        let obj = state.penalty_tariffs.find(item => item.id === payload.id)
        Object.keys(payload).forEach(item => {
            obj[item] = payload[item]
        })
    },
    [DELETE_PENALTY_TARIFF]: (state, payload) => {
        const obg = state.penalty_tariffs.find(item => item.id === payload.id)
        const obj_id = state.penalty_tariffs.indexOf(obg)
        if (obg) {
            state.penalty_tariffs.splice(obj_id, 1)
        }
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}